import { userPermissions, isOrganisationOwner } from "@/lib/utils";

export default {
  methods: {
    isOrganisationOwner() {
      return isOrganisationOwner();
    },
    userCan(group, action) {
      return !!(
        userPermissions() &&
        userPermissions()[group] &&
        userPermissions()[group][action]
      );
    }
  }
};
